/* Version: 3.5.149 */
'use client';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _toArray from '@babel/runtime/helpers/toArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React from 'react';
import { getExternalLink } from '../../utils/functions.js';
import { MOBILE_MENU_VARIANT } from './constants.js';

function hasActiveChild(children, activeKey) {
  if (!activeKey) {
    return false;
  }
  return React.Children.toArray(children).find(function (child) {
    var _child$props, _child$props2;
    var childKey = (_child$props = child.props) === null || _child$props === undefined ? undefined : _child$props.itemKey;
    // check grandchildren if key not already found
    var grandchildren = (_child$props2 = child.props) === null || _child$props2 === undefined ? undefined : _child$props2.children;
    if (grandchildren && childKey !== activeKey) {
      return React.Children.toArray(grandchildren).find(function (grandchild) {
        var _grandchild$props;
        return ((_grandchild$props = grandchild.props) === null || _grandchild$props === undefined ? undefined : _grandchild$props.itemKey) === activeKey;
      });
    }
    return childKey === activeKey;
  });
}

// add ref to the first nav item to work with SkipTo navigation links in the UtilityHeader
function addRefToFirstChild(children, ref) {
  return React.Children.map(children, function (child, index) {
    return index === 0 ? /*#__PURE__*/React.cloneElement(child, {
      ref: ref
    }) : child;
  });
}
function getLinkProps(href, isExternal) {
  return {
    href: href,
    target: getExternalLink(isExternal),
    rel: isExternal ? 'noopener noreferrer' : undefined
  };
}
function getNavItemProps(_ref) {
  var component = _ref.component,
    to = _ref.to,
    _ref$hasChildren = _ref.hasChildren,
    hasChildren = _ref$hasChildren === undefined ? false : _ref$hasChildren,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === undefined ? false : _ref$isExpanded,
    _ref$isExternal = _ref.isExternal,
    isExternal = _ref$isExternal === undefined ? false : _ref$isExternal;
  var ariaExpanded = hasChildren ? {
    'aria-expanded': isExpanded
  } : {};
  var navLink = {
    to: to
  };
  if (component === 'a') {
    navLink = getLinkProps(to, isExternal);
  }
  return _objectSpread(_objectSpread({}, ariaExpanded), navLink);
}
function getTabProps(_ref2) {
  var component = _ref2.component,
    to = _ref2.to,
    isExternal = _ref2.isExternal;
  if (component === 'a') {
    return getLinkProps(to, isExternal);
  }
  if (component === 'button') {
    return {
      type: 'button'
    };
  }
  return {
    to: to
  };
}
function isAccordion(theme) {
  return theme.sideNav.mobile.variant === MOBILE_MENU_VARIANT.ACCORDION;
}
function isOverlay(theme) {
  return theme.sideNav.mobile.variant === MOBILE_MENU_VARIANT.OVERLAY;
}
function renderSelectedTabContent(tabs, selectedTab, children, mainNavRef) {
  if (!tabs.length) {
    var _React$Children$toArr = React.Children.toArray(children),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      firstChild = _React$Children$toArr2[0],
      restChildren = _React$Children$toArr2.slice(1);
    var firstChildWithRef = /*#__PURE__*/React.cloneElement(firstChild, undefined, addRefToFirstChild(firstChild.props.children, mainNavRef));
    return [firstChildWithRef].concat(_toConsumableArray(restChildren));
  }
  var selectedTabIndex = tabs.findIndex(function (_ref3) {
    var value = _ref3.value;
    return value === selectedTab;
  });
  var selectedTabSection = React.Children.toArray(children)[selectedTabIndex];
  var selectedTabChildren = selectedTabSection === null || selectedTabSection === undefined ? undefined : selectedTabSection.props.children;
  return addRefToFirstChild(selectedTabChildren, mainNavRef);
}

export { addRefToFirstChild, getNavItemProps, getTabProps, hasActiveChild, isAccordion, isOverlay, renderSelectedTabContent };
